import { UserDataInput, User as UserOutput } from "@/schemas/user";
import { useUserSettingsCore } from "./useUserSettingsCore";
// The old updateFunctions and other complex logic are no longer needed here
// as useUserSettingsCore now handles saving via useUserOperations.

/**
 * Enhanced hook that provides user settings functionality.
 * This is now a simpler wrapper around the refactored useUserSettingsCore.
 */
export const useUserSettings = () => {
  const {
    userData, // This is UserOutput | null | undefined from FirebaseProvider via useUserSettingsCore
    formData, // This is UserDataInput from useUserSettingsCore
    setFormData, // The setter for formData
    isEditing,
    setIsEditing,
    isLoading, // Loading state from FirebaseProvider via useUserSettingsCore
    saveChanges, // The function to save formData using useUserOperations
    // toast, // toast can be used directly via useToast() in components if needed
  } = useUserSettingsCore();

  // The primary role of this wrapper is now to simply pass through the core functionalities.
  // Any additional logic specific to the public API of useUserSettings (if different from core)
  // would go here. For now, it's a direct pass-through.

  return {
    userData,
    formData,
    setFormData,
    isEditing,
    setIsEditing,
    isLoading,
    saveChanges,
    // updateUserData: saveChanges, // Alias if components expect 'updateUserData'
                                 // Or components can be updated to use 'saveChanges'
  };
};

// Export from the module (userDataUtils might be used elsewhere, so keep export)
export * from "./userDataUtils";
